export default __webpack_public_path__ + "media/images/logo/media/nhk-385123203a19ea7c4014904fd3461d78.png";